import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-panel animate__animated animate__bounceInRight animate__fast" }
const _hoisted_2 = { class: "login-form-wrap" }
const _hoisted_3 = { class: "account-control" }

import LoginAccount from '@/views/login/cpns/login-account.vue'
import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'login-panel',
  setup(__props) {

const accountRef = ref<InstanceType<typeof LoginAccount>>()
const isKeepPassword = ref<boolean>(true)

const handleLoginClick = () => {
  accountRef.value?.loginAction(isKeepPassword.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "login-title" }, [
      _createElementVNode("h2", null, "后台管理系统")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LoginAccount, {
        ref_key: "accountRef",
        ref: accountRef
      }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_checkbox, {
          modelValue: isKeepPassword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isKeepPassword).value = $event)),
          name: "type",
          class: "is-keep-password"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" 记住密码 ", -1)
          ]))]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_link, { type: "primary" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("忘记密码", -1)
          ]))]),
          _: 1
        })
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        class: "login-btn",
        onClick: handleLoginClick
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("立即登录", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})